"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SepratedPieChart = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const GlobalStateProvider_1 = require("../../GlobalStateProvider");
const SepratedPieChartStyled = styled_components_1.default.div `
	display: flex;
	align-items: center;
	gap: 18px;
	width: fit-content;

	.chart-wrap {
		position: relative;
		width: ${({ $size }) => `${$size}px`};
		height: ${({ $size }) => `${$size}px`};
		flex-shrink: 0;
	}

	.chart-percent {
		color: #101010;
		font-size: ${({ $isMobile }) => ($isMobile ? '13px' : '15px')};
		line-height: ${({ $isMobile }) => ($isMobile ? '20px' : '22px')};
		font-weight: 500;
	}

	.chart-center {
		position: absolute;
		inset: 0;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		text-align: center;
		pointer-events: none;
	}

	.chart-center-label {
		color: var(--color-grey-l, #83868a);
		font-size: 12px;
		line-height: 18px;
		font-weight: 400;
	}

	.chart-center-value {
		color: var(--color-black, #101010);
		font-size: 18px;
		line-height: 28px;
		font-weight: 700;
	}

`;
exports.SepratedPieChart = react_1.default.memo(({ data, size = 132, strokeWidth = 34, centerLabel, centerValue, minLabelPercentage = 0, }) => {
    const { isMobile } = (0, GlobalStateProvider_1.useGlobalState)();
    const radius = size / 2 - strokeWidth / 2;
    const circumference = 2 * Math.PI * radius;
    const total = data.reduce((sum, item) => sum + Math.max(item.value, 0), 0);
    const normalizedData = total > 0 ? data.filter(item => item.value > 0) : [];
    let accumulated = 0;
    return (react_1.default.createElement(SepratedPieChartStyled, { "$size": size, "$isMobile": isMobile },
        react_1.default.createElement("div", { className: "chart-wrap" },
            react_1.default.createElement("svg", { width: size, height: size, viewBox: `0 0 ${size} ${size}` },
                react_1.default.createElement("circle", { cx: size / 2, cy: size / 2, r: radius, fill: "none", stroke: "#edf0f5", strokeWidth: strokeWidth }),
                normalizedData.map(item => {
                    const dash = (item.value / total) * circumference;
                    const node = (react_1.default.createElement("circle", { key: item.id, cx: size / 2, cy: size / 2, r: radius, fill: "none", stroke: item.color, strokeWidth: strokeWidth, strokeLinecap: "butt", strokeDasharray: `${dash} ${circumference}`, transform: `rotate(-90 ${size / 2} ${size / 2})`, strokeDashoffset: -accumulated }));
                    accumulated += dash;
                    return node;
                }),
                normalizedData.map((item, index) => {
                    let start = 0;
                    for (let i = 0; i < index; i += 1) {
                        start += normalizedData[i].value;
                    }
                    const percentageValue = Math.round((item.value / total) * 100);
                    if (percentageValue < minLabelPercentage) {
                        return null;
                    }
                    const midRatio = (start + item.value / 2) / total;
                    const angle = -Math.PI / 2 + midRatio * Math.PI * 2;
                    // Place labels on the ring center line so each segment label sits consistently.
                    const labelRadius = radius;
                    const x = size / 2 + Math.cos(angle) * labelRadius;
                    const y = size / 2 + Math.sin(angle) * labelRadius;
                    const percentage = `${percentageValue}%`;
                    return (react_1.default.createElement("text", { key: `${item.id}-pct`, x: x, y: y, textAnchor: "middle", dominantBaseline: "middle", className: "chart-percent", fill: "#101010", fontSize: isMobile ? 13 : 15, fontWeight: 500 }, percentage));
                })),
            (centerLabel || centerValue) && (react_1.default.createElement("div", { className: "chart-center" },
                centerLabel && react_1.default.createElement("div", { className: "chart-center-label" }, centerLabel),
                centerValue && react_1.default.createElement("div", { className: "chart-center-value" }, centerValue))))));
});
